import { ReactElement } from 'react';
import { useRouter } from 'next/router';
import { Trans, useTranslation } from 'next-i18next';
import get from 'lodash/get';

import { LanguageCode } from '@Hotels-at-Home/hah-fe-core/dist/constants';
import Article from '~/ui/components/layouts/Article';
import { getRoutePostLink, generateLinkComponents } from '~/utils/blog';
import { postData } from '~/constants/blog';

const Post4 = (): ReactElement => {
  const { t: tArticle } = useTranslation('', { keyPrefix: '$local.$articles.$article4' });
  const { t: tNext } = useTranslation('', { keyPrefix: '$local.$articles.$article1' });

  const router = useRouter();
  const locale = router.locale as LanguageCode;

  const currentPostId = 4;
  const lastPostId = 1;

  let lastPostUrl = get(postData, [lastPostId, 'urls', locale]);
  lastPostUrl = getRoutePostLink(lastPostUrl, locale);

  const articleData = {
    id: currentPostId,
    hero: {
      heading: (
        <Trans
          i18nKey="title"
          t={tArticle}
          components={{
            sup: <sup />,
          }}
        />
      ),
      text: (
        <Trans
          i18nKey="subTitle"
          t={tArticle}
          components={{
            sup: <sup />,
            ...generateLinkComponents(tArticle, 13, 14),
          }}
        />
      ),
    },
    last: {
      url: lastPostUrl,
      id: lastPostId,
      heading: tNext('title'),
      text: tNext('subTitleCopy'),
      cta: tArticle('nextCta'),
    },
  };

  return (
    <Article id={articleData.id} hero={articleData.hero} last={articleData.last}>
      <h2>
        <Trans
          i18nKey="paragraphTitle1"
          t={tArticle}
          components={{
            sup: <sup />,
          }}
        />
      </h2>
      <p>
        <Trans
          i18nKey="paragraphText1"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
            sup: <sup />,
            ...generateLinkComponents(tArticle, 1, 4),
          }}
        />
      </p>
      <h2>{tArticle('paragraphTitle2')}</h2>
      <p>
        <Trans
          i18nKey="paragraphText2"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
            sup: <sup />,
            ...generateLinkComponents(tArticle, 5, 8),
          }}
        />
      </p>
      <h2>{tArticle('paragraphTitle3')}</h2>
      <p>
        <Trans
          i18nKey="paragraphText3"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
            sup: <sup />,
            ...generateLinkComponents(tArticle, 9, 9),
          }}
        />
      </p>
      <h2>
        <Trans
          i18nKey="paragraphTitle4"
          t={tArticle}
          components={{
            sup: <sup />,
          }}
        />
      </h2>
      <p>
        <Trans
          i18nKey="paragraphText4"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
            sup: <sup />,
            ...generateLinkComponents(tArticle, 10, 12),
          }}
        />
      </p>
      <p className="closing">
        <Trans
          i18nKey="paragraphText5"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
            sup: <sup />,
          }}
        />
      </p>
    </Article>
  );
};

export default Post4;
